export function statsSources_1() {
    return [
        { keywordId: '1', id: 42, name: 'Google Maps', position: 2, change: -3 },
        { keywordId: '1', id: 42, name: 'Яндекс', position: 7, change: 2 },
        { keywordId: '1', id: 42, name: '2GIS', position: 4, change: 0 }, // TODO keywordId - у бранча имя другое будет
    ]
}

export function statsSources_2() {
    return [
        { keywordId: '2', id: 42, name: 'Google Maps', position: 1, change: 2 },
        { keywordId: '2', id: 42, name: 'Яндекс', position: 4, change: 0 },
        { keywordId: '2', id: 42, name: '2GIS', position: 6, change: -1 },
    ]
}

export function statsSources_3() {
    return [
        { keywordId: '3', id: 42, name: 'Google Maps', position: 4, change: -4 },
        { keywordId: '3', id: 42, name: 'Яндекс', position: 2, change: 4 },
        { keywordId: '3', id: 42, name: '2GIS', position: 4, change: 8 },
    ]
}

export function statsSources_4() {
    return [
        { keywordId: '4', id: 42, name: 'Google Maps', position: 7, change: 6 },
        { keywordId: '4', id: 42, name: 'Яндекс', position: 4, change: 3 },
        { keywordId: '4', id: 42, name: '2GIS', position: 11, change: -3 },
    ]
}


export const BranchListMock = {
    status: 'ok',
    data: {
        paginator: {
            page: 1,
            has_previous: false,
            has_next: false,
            total_pages: 1,
            total_results: 3
        },
        time: {
            statsForDate: '24.10.2020', // на какое число статистика
            nextStatsUpdate: '01.11.2020', // когда следующее обновление статистики
        },
        branches: [
            {
                id: 1,
                name: 'Osterio Mario Сокол',
                address: 'Балтийская, 5',
            },
            {
                id: 2,
                name: 'Osterio Mario Метрополис',
                address: 'Большая малая, 13',
            },
            {
                id: 3,
                name: 'Osterio Mario на Белорусской',
                address: 'Малая Армянская, 47',
            },
            {
                id: 4,
                name: 'Osterio Mario Зябликово',
                address: 'Куликова, 8',
            },
        ],
    }
}


export const RankByBranchMock = {
    status: 'ok',
    data: {
        paginator: {
            page: 1,
            has_previous: false,
            has_next: false,
            total_pages: 1,
            total_results: 3
        },
        time: {
            statsForDate: '24.10.2020', // на какое число статистика
            nextStatsUpdate: '01.11.2020', // когда следующее обновление статистики
        },
        keywords: [
            {
                id: 'Osterio Mario сокол',
                name: 'Osterio Mario сокол',
                frequency: 13342,
                sources: statsSources_1()
            },
            {
                id: 'пицца на соколе',
                name: 'пицца на соколе',
                frequency: 4322,
                sources: statsSources_2()
            },
            {
                id: 'пицца',
                name: 'пицца',
                frequency: 8753,
                sources: statsSources_3()
            },
            {
                id: 'бизнес ланч сокол',
                name: 'бизнес ланч сокол',
                frequency: 8753,
                sources: statsSources_4()
            },
        ]
    }
}


export const KeywordListMock = {
    status: 'ok',
    data: {
        paginator: {
            page: 1,
            has_previous: false,
            has_next: false,
            total_pages: 1,
            total_results: 3
        },
        time: {
            statsForDate: '24.10.2020', // на какое число статистика
            nextStatsUpdate: '01.11.2020', // когда следующее обновление статистики
        },
        keywords: [
            {
                id: 'Osterio Mario сокол',
                name: 'Osterio Mario сокол',
                position: 1,
                frequency: 55342,
                usedInBranches: [1, 2, 3],
                sources: statsSources_1()
            },
            {
                id: 'пицца на соколе',
                name: 'пицца на соколе',
                position: 3,
                frequency: 543,
                usedInBranches: [1, 2, 3],
                sources: statsSources_2()
            },
            {
                id: 'пицца',
                name: 'пицца',
                position: 5,
                frequency: 876,
                usedInBranches: [1, 2, 3],
                sources: statsSources_3()
            },
            {
                id: 'бизнес ланч сокол',
                name: 'бизнес ланч сокол',
                position: 4,
                frequency: 7765,
                usedInBranches: [1, 2, 3],
                sources: statsSources_4()
            },
        ]
    }
}



export const RankByKeywordMock = {
    status: 'ok',
    data: {
        paginator: {
            page: 1,
            has_previous: false,
            has_next: false,
            total_pages: 1,
            total_results: 3
        },
        time: {
            statsForDate: '24.10.2020', // на какое число статистика
            nextStatsUpdate: '01.11.2020', // когда следующее обновление статистики
        },
        branches: [
            {
                id: 1,
                name: 'Osterio Mario Сокол',
                position: 1.4,
                sources: statsSources_1(),
            },
            {
                id: 2,
                name: 'Osterio Mario Метрополис',
                position: 3.7,
                sources: statsSources_2(),
            },
            {
                id: 3,
                name: 'Osterio Mario на Белорусской',
                position: 2.56,
                sources: statsSources_3(),
            },
            {
                id: 4,
                name: 'Osterio Mario Зябликово',
                position: 2.56,
                sources: statsSources_4(),
            },
        ],
    }
}


export const PositionHistoryMock = {
    type: "OK",
    data: [
        {
            date: '30.10.2020',
            position: 3,
        },
        {
            date: '30.10.2020',
            position: 3,
        },
        {
            date: '30.10.2020',
            position: 3,
        },
    ],
}

export async function fetchKeywordPositionHistoryBySource(source) {
    source.keywordId
    source.id
    return [
        {
            date: '30.10.2020',
            position: 3,
        },
        {
            date: '23.10.2020',
            position: 7,
        },
        {
            date: '16.10.2020',
            position: 5,
        },
        {
            date: '09.10.2020',
            position: 9,
        },
        {
            date: '02.10.2020',
            position: 6,
        },
    ]
}

export async function fetchKeywordBranches(keywordId) {
    return [
        'fffffffffff',
        'rrrrrrrrrrrrrr',
        'hhhhhhhhhhhh',
        'wwwwwwwwwwwwwwww',
    ]
}